"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrustType = exports.TaxType = exports.ReturnType = exports.IDType = exports.EntityType = exports.Capacity = void 0;
var IDType = {
  None: 0,
  RSA_Id: 1,
  Passport: 2,
  CompanyRegistrationNumber: 3,
  TrustNumber: 4
};
exports.IDType = IDType;
var TaxType = {
  //sdsslookupmaster table 12
  None: 0,
  PIT: 1,
  PAYE: 2,
  VAT: 3,
  UIF: 10,
  SDL: 11,
  CUS: 12,
  Excise: 26,
  CIT: 28,
  Trusts: 29,
  ExemptInstitution: 31,
  TransferDuty: 32,
  MPRR: 33,
  STT: 34,
  DividendTax: 35,
  APT: 36,
  WTI: 37,
  PITFraud: 38,
  CCC: 99
};
exports.TaxType = TaxType;
var Capacity = {
  //sdssLookupMaster Table 18
  None: 0,
  Taxpayer: 1,
  TaxPractitioner: 4,
  Representative: 5
};
exports.Capacity = Capacity;
var EntityType = {
  //sdssLookupMaster Table 26
  None: "0",
  Individual: "1",
  Company: "2",
  Trust: "3",
  Other: "4",
  LBC: "5",
  HNWI: "6",
  eCommerce: "7"
};
exports.EntityType = EntityType;
var TrustType = {
  //sdssLookupMaster Table 41
  None: 0,
  Intervivos: 1,
  Testamentary: 2,
  Foreign: 3,
  CollectiveInvestment: 4,
  SpecialAIntervivos: 5,
  SpecialATestamentary: 6,
  SpecialBTestamentary: 7
};
exports.TrustType = TrustType;
var ReturnType = {
  //sdssLookupMaster Table 118
  None: 0,
  ITR12: 1,
  ITR14: 2,
  IT12TR: 3,
  IT12EI: 4,
  IRP6: 5,
  DTR01: 6,
  DTR02: 7,
  EMP201: 8,
  EMP501: 9,
  VAT201: 10,
  APT201: 11,
  MPR02: 12,
  MPR03: 13,
  STT: 14,
  TDC01: 15,
  WTI02: 17,
  DA176: 18,
  DA161A: 19,
  DA159: 20,
  DA162: 21,
  DA179: 22,
  DA267: 23,
  DL163: 24,
  DA75: 25,
  DA265: 26,
  DA177: 27,
  DA266: 28,
  DA263: 29,
  DA264: 30,
  DA261: 31,
  DA262: 32,
  DA160: 33,
  DA178: 34,
  DA180: 35,
  RAV01: 36
};
exports.ReturnType = ReturnType;